import { h } from '@stencil/core';

const Icon = ({ width = '100%', height = '100%' }) => {
  return (
    <svg width={width} height={height} id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512">
      <g>
        <path
          fill="none"
          stroke="#131313"
          stroke-width="13"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="M257.595,419.411c-89.139,0-161.654-72.558-161.654-161.745s72.515-161.74,161.654-161.74c89.135,0,161.65,72.554,161.65,161.74 S346.73,419.411,257.595,419.411z"
        />

        <path
          fill="none"
          stroke="#131313"
          stroke-width="13"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="M95.569,402.695c-38.711-38.746-60.032-90.252-60.032-145.029c0-53.033,20.156-103.349,56.764-141.675"
        />

        <path
          fill="none"
          stroke="#131313"
          stroke-width="13"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="M416.696,402.695c38.711-38.746,60.032-90.252,60.032-145.029c0-53.033-20.156-103.349-56.764-141.675"
        />
        <g>
          <path
            fill="#111111"
            d="M170.879,276.594l-6.037,21.079h-19.881l25.918-82.121h25.167l26.295,82.121h-20.636l-6.542-21.079 H170.879z M192.397,262.706l-5.286-17.426c-1.51-4.872-3.021-10.966-4.277-15.838h-0.254c-1.256,4.872-2.516,11.089-3.899,15.838 l-5.032,17.426H192.397z"
          />
          <path
            fill="#111111"
            d="M233.62,216.649c5.036-0.977,15.227-1.707,24.789-1.707c11.701,0,18.871,1.096,25.035,4.63 c5.914,3.045,10.191,8.652,10.191,16.084c0,7.31-4.404,14.135-13.962,17.545v0.242c9.686,2.561,16.856,9.628,16.856,20.229 c0,7.429-3.521,13.281-8.803,17.422c-6.169,4.753-16.482,7.433-33.342,7.433c-9.44,0-16.482-0.612-20.763-1.219L233.62,216.649 L233.62,216.649z M252.618,248.083h6.292c10.068,0,15.477-4.018,15.477-10.113c0-6.214-4.909-9.501-13.589-9.501 c-4.153,0-6.542,0.242-8.18,0.484L252.618,248.083L252.618,248.083z M252.618,284.515c1.888,0.242,4.153,0.242,7.424,0.242 c8.68,0,16.355-3.168,16.355-11.82c0-8.282-7.675-11.574-17.233-11.574h-6.546V284.515z"
          />
          <path
            fill="#111111"
            d="M310.208,278.544c5.155,2.557,13.084,5.118,21.26,5.118c8.808,0,13.466-3.534,13.466-8.894 c0-5.118-4.026-8.044-14.217-11.578c-14.094-4.749-23.279-12.304-23.279-24.243c0-14.012,12.079-24.736,32.082-24.736 c9.563,0,16.61,1.949,21.641,4.141l-4.277,14.988c-3.398-1.584-9.435-3.899-17.738-3.899c-8.307,0-12.333,3.657-12.333,7.921 c0,5.237,4.781,7.552,15.727,11.574c14.972,5.36,22.019,12.916,22.019,24.49c0,13.77-10.946,25.466-34.221,25.466 c-9.69,0-19.253-2.438-24.034-4.995L310.208,278.544z"
          />
        </g>
      </g>
    </svg>
  );
};

export default Icon;
